var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBsrmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 50,
    viewBox: "0 0 170 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.62598 24.5215C6.62598 24.5215 11.0716 14.5884 25.5852 14.8065C25.5852 14.8065 33.8297 15.1021 39.2082 20.943C39.2082 20.943 38.0031 24.0289 36.5825 25.4328C36.5825 25.4328 33.3632 20.4152 23.5638 20C21.5407 19.9816 19.5366 20.3896 17.6832 21.1974C15.8298 22.0052 14.1691 23.1944 12.8102 24.6869C12.8102 24.6869 15.6373 28.9093 22.7651 29.9895C23.3341 32.3364 25.207 35.0704 25.207 35.0704C25.207 35.0704 11.3614 34.4195 6.62598 24.5215Z",
    fill: "url(#paint0_linear_524_4369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.2634 20.0212C22.2634 20.0212 20.288 27.9698 25.1753 35.1091C30.0626 42.2485 39.0422 44.4828 42.6291 43.9937C42.6291 43.9937 48.4599 35.9747 42.9824 24.5813C41.954 26.4403 40.6292 28.1206 39.0598 29.5567C39.0598 29.5567 41.0812 35.556 39.385 38.6419C36.2257 38.29 32.1087 37.3435 28.9565 31.9916C28.9565 31.9916 26.5288 28.5469 27.6702 20.4364C25.8889 20.099 24.0755 19.9598 22.2634 20.0212Z",
    fill: "url(#paint1_linear_524_4369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.4119 14.8065C24.4119 14.8065 30.0837 5.86909 42.4664 5.21814C42.4664 5.21814 47.4562 12.8642 44.4206 21.9282C44.4206 21.9282 41.5299 31.3863 30.7233 34.4616C30.1513 33.7604 29.618 33.0286 29.126 32.2695C28.6689 31.5849 28.3219 30.8334 28.0977 30.0422C28.0977 30.0422 35.3704 28.8423 38.2293 22.9029C38.2293 22.9029 41.9752 17.0619 39.2081 10.8972C37.4667 11.0212 35.7715 11.5123 34.235 12.3379C32.6985 13.1635 31.3558 14.3048 30.2957 15.6861C28.3872 15.1125 26.4055 14.8162 24.4119 14.8065Z",
    fill: "url(#paint2_linear_524_4369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M76.031 22.1498C76.031 22.1498 79.5472 21.6009 79.5472 17.1287C79.5472 12.1147 72.5184 12.4665 72.5184 12.4665H55.1494V32.076H73.5255C76.4586 32.076 80.0031 30.9817 80.0031 27.09C80.0031 23.1984 76.031 22.1498 76.031 22.1498ZM60.5916 15.9922L71.7126 15.8867C72.324 15.8867 73.9107 15.8867 73.9107 18.1984C73.9107 20.5102 71.4653 20.5102 71.4653 20.5102H60.5916V15.9922ZM71.4653 28.5397H60.5916V24.0218L71.1932 23.9162C72.9424 23.9162 74.1157 24.2681 74.1157 26.2315C74.1051 28.5397 71.4653 28.5397 71.4653 28.5397ZM100.09 20.3905H91.2125C89.3784 20.3905 88.7388 19.4123 88.8201 17.836C88.9084 16.0485 91.2938 16.0098 91.2938 16.0098H105.306L105.412 12.4912H88.8448C88.8448 12.4912 82.3814 12.2484 82.3814 18.0893C82.3814 23.9303 88.3288 24.0499 88.3288 24.0499H96.5168C96.8702 24.0499 100.305 23.8071 100.305 26.1189C100.305 28.4306 97.4957 28.3251 97.4957 28.3251H83.3214V32.0795H100.673C100.673 32.0795 107.034 31.1752 107.034 25.9429C107.034 20.7107 100.093 20.3905 100.093 20.3905H100.09ZM130.771 18.4412C130.771 12.4384 124.904 12.4419 124.904 12.4419H108.96V32.0689H114.674V24.4335H120.021L125.07 32.0689H131.93L126.226 24.1203C126.226 24.1203 130.774 24.444 130.774 18.4412H130.771ZM121.904 21.1857H114.674V15.9254H121.657C121.657 15.9254 124.424 15.9254 124.424 18.3673C124.424 20.8092 122.975 21.1857 121.908 21.1857H121.904ZM154.546 12.7234L148.185 26.9598L141.955 12.6038H133.665V32.0689H139.287V17.5897L145.397 32.076H151.14L157.373 18.0788V32.0689H162.872V12.7163L154.546 12.7234Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_4369",
    x1: 6.67545,
    y1: 28.6243,
    x2: 41.3679,
    y2: 21.0214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_524_4369",
    x1: 27.2921,
    y1: 39.0782,
    x2: 36.2842,
    y2: 26.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_524_4369",
    x1: 46.9579,
    y1: 12.4032,
    x2: 30.7464,
    y2: 22.1729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsrmLogo);
export default __webpack_public_path__ + "static/media/bsrm-logo.61d2c653f8dc31febc97699974308643.svg";
export { ForwardRef as ReactComponent };